module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/css/logout.component.css
// module id = ./src/app/modules/housekeeping/css/logout.component.css
// module chunks = main